import { randomInRange } from '~/bootcamp/Activities/utils/activities.utils'

/**
 * It generates a random numerator and denominator, and then validates the numerator against the
 * history
 * @param {number} minNumerator - The minimum value for the numerator.
 * @param {number} maxNumerator - The maximum value of the numerator.
 * @param {number} maxDenominator - The maximum denominator that can be generated.
 * @param {number[]} history - an array of numbers that have already been used in the current activity.
 * @returns { numerator: number; denominator: number }
 */

export function generateDenominatorNumerator(
  minNumerator: number,
  maxNumerator: number,
  maxDenominator: number,
  history: number[],
): { numerator: number; denominator: number } {
  let numerator = randomInRange(minNumerator, maxNumerator + 1)
  numerator = validateNumberWithHistory(numerator, minNumerator, maxNumerator, history)
  const denominator = randomInRange(numerator + 1, maxDenominator + 1)
  return { numerator, denominator }
}

function validateNumberWithHistory(currentValue: number, min: number, max: number, history: number[]): number {
  if (history.includes(currentValue)) {
    currentValue++
    if (currentValue > max) {
      currentValue = min
    }
    return validateNumberWithHistory(currentValue, min, max, history)
  }
  return currentValue
}
